import { Vue } from 'vue-class-component';

import CopyInput from '@/components/copy-input/copy-input';
import { link } from '@/transformers/sharing';
import { PortalPageType, RavnurApplication } from '@/types/Auth';
import { Media } from '@/types/Media';
import { ApplicationTypes } from '@Ravnur-Inc/shared/types/Application';

import './media-link-item.scss';
import LaunchButton from '@/components/launch-button/launch-button';

const CN = 'media-link-item';

class Props {
  media: Media;
  application: Partial<RavnurApplication>;
  pageType: PortalPageType;
  withoutLabel?: boolean;
}

export default class MediaLinkItem extends Vue.with(Props) {
  private get host() {
    const host = this.application.portalUrl || '';

    if (this.application.applicationType === ApplicationTypes.EXTERNAL) {
      return `${host}public`;
    }

    if (this.application.applicationType === ApplicationTypes.PUBLIC) {
      return `${host}`;
    }

    return `${host}/#/`;
  }

  private get link() {
    return link(this.host, this.media, this.pageType);
  }

  private get applicationName() {
    return this.application.name;
  }

  render() {
    return (
      <li class={CN}>
        <div class={`${CN}__content`}>
          {!this.withoutLabel && <span class={`${CN}__portal-name`}>{this.applicationName}</span>}
          <div class={`${CN}__link`}>
            <CopyInput value={this.link} />
            <LaunchButton href={this.link} />
          </div>
        </div>
      </li>
    );
  }
}
